import * as Yup from 'yup';
import { ALPHA_LOWERCASE, ALPHA_UPPERCASE, EMAIL, PASSWORD } from 'src/constants/regex.constants';

export const signupValidationSchema = Yup.object().shape({
  name: Yup.string().required('Please enter your full name'),
  email: Yup.string()
    .matches(EMAIL, 'Please enter a valid email address')
    .required('Please enter your email'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters long')
    .matches(ALPHA_LOWERCASE, 'Password must contain at least one lowercase letter')
    .matches(ALPHA_UPPERCASE, 'Password must contain at least one uppercase letter')
    .matches(PASSWORD, 'Password must contain at least One special character')
    .required('Please enter a password'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), undefined], 'Passwords did not match. Please try again.')
    .required('Please re-enter the password')
});

export default signupValidationSchema;
